import loadable from "@loadable/component";
import { ErrorBoundary } from "../../components";
import FullPageLoader from "@Components/FullPageLoader";

const AsyncAmbassadorV2 = loadable(() => import("./AmbassadorV2"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <AsyncAmbassadorV2 {...props} />
  </ErrorBoundary>
);
